import { render } from "./CreateGoalByLib_Goals.vue?vue&type=template&id=4b0756a4"
import script from "./CreateGoalByLib_Goals.vue?vue&type=script&lang=js"
export * from "./CreateGoalByLib_Goals.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__